import React, { useState, useEffect } from 'react';
import { supabase } from './supabase';
function English() {
  const [words, setWords] = useState([]);
  const [checks, setChecks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [todayChecked, setTodayChecked] = useState(false);
  const [expanded, setExpanded] = useState(null);
  const [streak, setStreak] = useState(0);
  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    const { data: wordsData } = await supabase
      .from('english_words')
      .select('*')
      .order('date', { ascending: false });
    const { data: checksData } = await supabase
      .from('english_checks')
      .select('*');
    const todayStr = new Date().toISOString().split('T')[0];
    const { data: dailyData } = await supabase
      .from('english_daily')
      .select('*')
      .order('date', { ascending: false });
    setWords(wordsData || []);
    setChecks(checksData || []);
    const todayDone = (dailyData || []).some(d => d.date === todayStr);
    setTodayChecked(todayDone);
    let count = 0;
    const sorted = (dailyData || []).sort((a, b) => new Date(b.date) - new Date(a.date));
    const today = new Date();
    for (let i = 0; i < sorted.length; i++) {
      const expected = new Date(today);
      expected.setDate(expected.getDate() - i);
      const expectedStr = expected.toISOString().split('T')[0];
      if (sorted[i].date === expectedStr) {
        count++;
      } else {
        break;
      }
    }
    setStreak(count);
    setLoading(false);
  };
  const checkIn = async () => {
    const todayStr = new Date().toISOString().split('T')[0];
    const { error } = await supabase
      .from('english_daily')
      .insert([{ date: todayStr }]);
    if (!error) {
      setTodayChecked(true);
      setStreak(prev => prev + 1);
    }
  };
  const toggleRemembered = async (wordId) => {
    const existing = checks.find(c => c.word_id === wordId);
    if (existing) {
      const newVal = !existing.remembered;
      await supabase
        .from('english_checks')
        .update({ remembered: newVal })
        .eq('id', existing.id);
      setChecks(prev => prev.map(c => c.id === existing.id ? {...c, remembered: newVal} : c));
    } else {
      const { data } = await supabase
        .from('english_checks')
        .insert([{ word_id: wordId, remembered: true }])
        .select();
      if (data) {
        setChecks(prev => [...prev, data[0]]);
      }
    }
  };
  const isRemembered = (wordId) => {
    const check = checks.find(c => c.word_id === wordId);
    return check ? check.remembered : false;
  };
  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    return (d.getMonth() + 1) + '.' + d.getDate();
  };
  const todayWord = words.length > 0 ? words[0] : null;
  return (
    <div className="english">
      <div className="english-header">
        <div className="english-title">英语⻆</div>
        <div className="english-streak">
          {streak > 0 ? streak + ' day streak' : 'start today'}
        </div>
      </div>
      {!todayChecked ? (
        <button className="english-checkin-btn" onClick={checkIn}>
今⽇打卡
        </button>
      ) : (
        <div className="english-checkin-done">今⽇已打卡</div>
      )}
      {todayWord && (
        <div className="english-today">
          <div className="today-label">TODAY</div>
          <div className="today-word">{todayWord.word}</div>
          <div className="today-meaning">{todayWord.meaning}</div>
          {todayWord.example && (
            <div className="today-example">"{todayWord.example}"</div>
          )}
          {todayWord.notes && (
            <div className="today-notes">{todayWord.notes}</div>
          )}
        </div>
      )}
      <div className="english-list-header">
        <span>单词本</span>
        <span className="english-count">{words.length} words</span>
      </div>
      <div className="english-list">
        {loading ? (
          <div className="english-empty">加载中...</div>
        ) : words.length === 0 ? (
          <div className="english-empty">还没有单词</div>
        ) : (
          words.map((w) => (
            <div
              key={w.id}
              className={'english-card' + (expanded === w.id ? ' expanded' : '')}
              onClick={() => setExpanded(expanded === w.id ? null : w.id)}
            >
              <div className="english-card-top">
                <div className="english-card-word">{w.word}</div>
                <div className="english-card-right">
                  <div className="english-card-date">{formatDate(w.date)}</div>
                  <button
                    className={'remember-btn' + (isRemembered(w.id) ? ' yes' : '')}
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleRemembered(w.id);
                    }}
                  >
                    {isRemembered(w.id) ? '记住了' : '还没记'}
                  </button>
                </div>
              </div>
              <div className="english-card-meaning">{w.meaning}</div>
              {expanded === w.id && (
                <>
                  {w.example && <div className="english-card-example">"{w.example}"</div>}
                  {w.notes && <div className="english-card-notes">{w.notes}</div>}
                </>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
}
export default English